module.exports = __webpack_public_path__ + "static/img/ktx_c.69660c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/ktx_c.png
// module id = i8GS
// module chunks = 16